import { parseISO, isValid, format as dfFormat } from 'date-fns';

export const formatAssetStatus = (status) => {
  if (!status) return 'N/A';
  
  // Normalize for comparison
  const normalized = status.toLowerCase();
  
  switch (normalized) {
    case 'in_storage':
    case 'available':
      return 'Available';
    case 'checked_out':
    case 'in use':
      return 'In Use';
    case 'in_repair':
    case 'in repair':
      return 'In Repair';
    case 'retired':
      return 'Retired';
    case 'broken':
      return 'Broken';
    case 'written off':
    case 'written_off':
    case 'written-off':
      return 'Written-Off';
    case 'lost':
    case 'lost/stolen':
      return 'Lost/Stolen';
    default:
      return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
  }
};

export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '0.00';
  return parseFloat(amount).toFixed(2);
};

/**
 * formatDate
 * @param {string|Date} dateString - raw date input (ISO string, timestamp, Date)
 * @param {string} preferredFormat - one of 'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'
 * @returns {string} formatted date or 'Invalid Date' / 'N/A'
 */
export const formatDate = (dateString, preferredFormat = 'DD/MM/YYYY') => {
  if (!dateString) return 'N/A';

  // Map app preference to date-fns tokens
  const tokenMap = {
    'DD/MM/YYYY': 'dd/MM/yyyy',
    'MM/DD/YYYY': 'MM/dd/yyyy',
    'YYYY-MM-DD': 'yyyy-MM-dd',
  };

  const formatToken = tokenMap[preferredFormat] || tokenMap['DD/MM/YYYY'];

  // Try parse as ISO first, then fallback to native Date
  let date;
  try {
    date = typeof dateString === 'string' ? parseISO(dateString) : new Date(dateString);
  } catch (err) {
    date = new Date(dateString);
  }

  if (!isValid(date)) return 'Invalid Date';

  try {
    return dfFormat(date, formatToken);
  } catch (err) {
    return 'Invalid Date';
  }
};

// Backwards-compatible wrapper used across the app
export const formatAppDate = (dateString, formatType = 'DD/MM/YYYY') => formatDate(dateString, formatType);
